import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled, // for the parent UL, not the children.
  ColStyled,
  LinkStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-about-us';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-about-us-${baseIdSuffix}`}
        linkUrl='/who-we-are/'
        variant='primaryDeemphasize'>
        About Us
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-working-with-an-advisor-${baseIdSuffix}`}
        linkUrl='/financial-advisor/'
        variant='primaryDeemphasize'>
        Working with an Advisor
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-financial-information-${baseIdSuffix}`}
        linkUrl='/financial-information/'
        variant='primaryDeemphasize'>
        Financial Information
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-sustainability-report-${baseIdSuffix}`}
        linkUrl='/who-we-are/sustainability-impact/'
        variant='primaryDeemphasize'>
        Sustainability Report
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-our-leaders-${baseIdSuffix}`}
        linkUrl='/leaders/'
        variant='primaryDeemphasize'>
        Our Leaders
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-our-commitment-to-diversity-${baseIdSuffix}`}
          linkUrl='/our-commitment-to-diversity/'
          variant='primaryDeemphasize'>
          Our Commitment to Diversity
        </LinkStyled>
        <BulletedList
          bulletedListData={[{
            bulletText: (
              <Link
                id={`${baseIdPrefix}-supplier-diversity-${baseIdSuffix}`}
                linkUrl='/supplier-diversity/'
                variant='primaryDeemphasize'>
                Supplier Diversity
              </Link>
            ),
          }]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-philanthropy-${baseIdSuffix}`}
        linkUrl='/philanthropy/'
        variant='primaryDeemphasize'>
        Philanthropy
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-northwestern-mutual-subsidiaries-${baseIdSuffix}`}
        linkUrl='/northwestern-mutual-subsidiaries/'
        variant='primaryDeemphasize'>
        Northwestern Mutual Subsidaries
      </Link>
    ),
  },
];

export default () => (
  <ColStyled
    id='sitemap-about-us-list'
    medium={6}>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      About Us
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'
    />
  </ColStyled>
);
